module.exports = __webpack_public_path__ + "img/Illustration-02.37248b58.png";